var angular = require('angular');

require('angular-ui-router');

angular.module('ikeweb.routes', ['ui.router']);

require('./routes.config.js');
require('./routes.js');



//////////////////
// WEBPACK FOOTER
// ./src/client/routes/routes.module.js
// module id = 422
// module chunks = 0